module.exports = __webpack_public_path__ + "img/customise-column-icon.3b0d91b7.svg";